var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mobile-map',{directives:[{name:"show",rawName:"v-show",value:(this.$route.name === 'ngMap' || this.$route.name === 'WebMap'),expression:"this.$route.name === 'ngMap' || this.$route.name === 'WebMap'"}]}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }